// wrapper for fullcalendar.js - adds support for schedules and color coding, also adds support for reocurring schedules.
var VeritracksTreeDisplayController = function (aId, aOptions) {
    var mDataSource = [],
        mListId = aId,
        mOverflow = false;

    if (aOptions) {
        if (!isNullOrUndefined(aOptions.Overflow)) {
            mOverflow = aOptions.Overflow;
        }
    }
    this.buildGraphTree = function (list, keyList) {
        var lItem,
            lOriPaths,
            newNode,
            newVertex,
            index,
            heads = [],
            html = [],
            smallIndex = 99999999,
            currentIndex = 99999999,
            isBuildOriTreeFlat = false,
            dirtyOriPath = [],
            dirtyIndex = [],
            headsIndex = [],
            dirtyValue = [],
            graphIndex = [],
            graph = [];
        

        for (var key in mDataSource) {
            if (mDataSource.hasOwnProperty(key)) {
                lItem = mDataSource[key];
                if (lItem.OriPath.indexOf("+") == -1) {
                    isBuildOriTreeFlat = true;
                    break;
                }
                lOriPaths = lItem.OriPath.split("+");
                if (lOriPaths.length > 1) {
                    index = graphIndex.indexOf(lOriPaths[lOriPaths.length - 2]);
                    if (index != -1) {
                        newNode = graph[index];
                        newVertex = new vertex();
                        newVertex.weight = 1;
                        newVertex.value = lItem.Name.trim();
                        newNode.vertices.push(newVertex);
                        newNode = new node();
                        newNode.value = lItem.Id;
                        newNode.edges = lOriPaths.length - 2;
                        currentIndex = lOriPaths.length - 2;
                        graph.push(newNode);
                        graphIndex.push(lItem.Name.toUpperCase().trim());
                    } else {
                        newNode = new node();
                        newNode.value = lItem.Id;
                        newNode.edges = lOriPaths.length - 2;
                        currentIndex = lOriPaths.length - 2;
                        dirtyOriPath.push(lOriPaths[lOriPaths.length - 2]);
                        dirtyIndex.push(lOriPaths.length - 2);
                        dirtyValue.push(lItem.Id);
                        graph.push(newNode);
                        graphIndex.push(lItem.Name.toUpperCase().trim());
                    }

                    //find the smallest tree level
                    if (currentIndex < smallIndex) {
                        smallIndex = currentIndex;
                        headsIndex.push(smallIndex);
                    }

                }//end of if
            }//end of outer if
        }//end of for    

        if (isBuildOriTreeFlat) {
            populateOrganiationsListNoTree(mDataSource);
        } else {

            for (var lKey in dirtyOriPath) {
                if (dirtyOriPath.hasOwnProperty(lKey) && graphIndex.indexOf(dirtyOriPath[lKey]) == -1 && headsIndex.indexOf(dirtyIndex[lKey]) == -1) {
                    headsIndex.push(dirtyIndex[lKey]);
                }
            }
            //find the head
            for (var headIndex in graph) {
                if (graph.hasOwnProperty(headIndex) && headsIndex.indexOf(graph[headIndex].edges) != -1 && dirtyValue.indexOf(graph[headIndex].value) != -1) {
                    heads.push(headIndex);
                }
            }//end of for

            html.push('<ul id="parentList" class="OriUlCommon">');
            html.push('</ul>');
            $('#'+mListId).html('');
            $('#' + mListId).html(html.join(''));

            if (mOverflow) {
                $('#' + mListId).css('overflow', '');
            }
            for (var head in heads) {
                if (heads.hasOwnProperty(head)) {
                    //depth first search
                    dfs(graph, heads[head], graph[heads[head]].edges, graphIndex, "parentList", list, keyList);
                }
            }
            $("#uOrganizationSearchHolder").css("display", "block");
        }


    }//end of function


    this.buildFlatTree = function (aData) {
        "use strict";
        populateOrganiationsListNoTree(aData);
    }

    function populateOrganiationsListNoTree(aData) {
        "use strict";
        var lBuilder = new SumoPredicateBuilder(),
            lSort = new SortExpression();
        lSort.addAscendingColumn('Name');
        aData = lSort.sort(aData);

        var lHtml = [],
            lItem,
            lKey;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                lHtml.push('<div>');

                lHtml.push('<input type="checkbox" id="uOrganizationSelect');
                lHtml.push(lItem.Id);
                lHtml.push('" value="');
                lHtml.push(lItem.Id);
                lHtml.push('" class="SuperUserOrganization" /> ');
                lHtml.push('<label for="uOrganizationSelect');
                lHtml.push(lItem.Id);
                lHtml.push('">');
                lHtml.push('');
                lHtml.push('');

                lHtml.push(lItem.Name);
                if (lItem.ParentOriFlag == 1 && mEnabledSuperOri) {
                    lHtml.push("-- Parent Organization");
                }
                lHtml.push('</label>');
                lHtml.push('</div>');
            }
        }
        $('#uOrganizationHolder').html(lHtml.join(''));
        //hide search box
       $("#uOrganizationSearchHolder").css("display", "none");

    }


    function dfs(g, v, edgeCount, graphIndex, itemToAppend, list, keyList) {
        "use strict";

        var next,
            index,
            newNode,
            oldNode,
            oriIndex,
            item,
            html = [];

        if (!g[v].visited) {
            oriIndex = keyList.indexOf(g[v].value);
            item = list[oriIndex];

            if (g[v].vertices.length == 0) {
                html.push('<li id="' + item.Id + '" class="OriLiCommon"><a id="link' + item.Id + '" class="openOriParent notParentLink" href="javascript:void(0);" onClick="showHideOriChildren(' + item.Id + ');"></a> ');
            } else {
                html.push('<li id="' + item.Id + '" class="OriLiCommon"><a id="link' + item.Id + '" class="openOriParent plusSignImage" href="javascript:void(0);" onClick="showHideOriChildren(' + item.Id + ');"></a> ');
            }

            html.push('<input type="checkbox" id="uOrganizationSelect');
            html.push(item.Id);
            html.push('" value="');
            html.push(item.Id);
            html.push('" class="SuperUserOrganization" /> ');
            html.push('<label for="uOrganizationSelect');
            html.push(item.Id);
            html.push('">');
            html.push('');
            html.push('');

            html.push(item.Name);
            if (item.ParentOriFlag == 1 && mEnabledSuperOri) {
                html.push("-- Parent Organization");
            }
            html.push('</label>');
            html.push('<ul id="ul' + item.Id + '" class="OriUlCommonHide">');
            html.push('</ul>');
            html.push('</li>');
            $('#' + itemToAppend).append(html.join(''));
            itemToAppend = "ul" + item.Id;
            g[v].visited = true;

            for (var key in g[v].vertices) {
                if (g[v].vertices.hasOwnProperty(key)) {
                    next = g[v].vertices[key].value.toUpperCase();
                    index = graphIndex.indexOf(next);

                    if (index != -1 && !g[index].visited && g[index].edges == edgeCount + 1) {

                        dfs(g, index, g[index].edges, graphIndex, itemToAppend, list, keyList);
                    }
                }

            }//end of for  
        }//end of if


        return;

    }

    //for the directed graph
    function node() {
        this.value = 0;
        this.visited = false;
        this.edges = 0;
        this.vertices = [];
    }

    function vertex() {
        this.value = 0;
        this.weight = 0;
    }

    this.setDataSource = function (aDataSource) {
        if (aDataSource) {
            mDataSource = aDataSource;
        }
    }

};
